import AppImages from "../assets/AppImages";
import DashboardHome from "../pages/Dashboard/Home";
import DashboardNone from "../pages/Dashboard/None";
import DashboardVehicleInventory from "../pages/Dashboard/Vehicle/Inventory";
import { DashboardVehicleInventoryDetails } from "../pages/Dashboard/Vehicle/Details";
import DashboardVehicleDelivery from "../pages/Dashboard/Vehicle/Delivery";
import DashboardPartsDelivery from "../pages/Dashboard/Parts/Delivery";
import DashboardPartsInventory from "../pages/Dashboard/Parts/Inventory";
import { DashboardPartsInventoryDetails } from "../pages/Dashboard/Parts/Details";
import DashboardPartsRequests from "../pages/Dashboard/Parts/Requests";
import DashboardEmployees from "../pages/Dashboard/Employees";
import DashboardVehiclePurchaseInventory from "../pages/Dashboard/Vehicle/PurchaseInventory";

export interface DashboardPage {
    link: string;
    title: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    adminOnly?: boolean;
    subOnly?: boolean;
    child?: DashboardPage[];
    component: React.FC;
    hidden?: boolean;
    showToRoles?: string[];
}

export const dashboard_pages: DashboardPage[][] = [
    [
        {
            title: "Home",
            link: "home",
            icon: AppImages.IconHome,
            component: DashboardHome,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            title: "Vehicles",
            link: "vehicles",
            icon: AppImages.IconVehicles,
            component: DashboardNone,
            child: [
                {
                    title: "Inventory",
                    link: "vehicles/inventory",
                    icon: AppImages.IconVehicles,
                    component: DashboardVehicleInventory,
                },
                {
                    title: "Details",
                    link: "vehicles/inventory/:vin",
                    icon: AppImages.IconVehicles,
                    component: DashboardVehicleInventoryDetails,
                    hidden: true,
                },
                {
                    title: "Deliveries",
                    link: "vehicles/deliveries",
                    icon: AppImages.IconVehicles,
                    component: DashboardVehicleDelivery,
                    showToRoles: ["SuperUser", "Admin", "Mechanic", "Parts Analyst"],
                },
            ],
        },
        {
            title: "Parts",
            link: "parts",
            icon: AppImages.IconParts,
            component: DashboardNone,
            child: [
                {
                    title: "Inventory",
                    link: "parts/inventory",
                    icon: AppImages.IconVehicles,
                    component: DashboardPartsInventory,
                },
                {
                    title: "Details",
                    link: "parts/inventory/:id",
                    icon: AppImages.IconVehicles,
                    component: DashboardPartsInventoryDetails,
                    hidden: true,
                },
                {
                    title: "Deliveries",
                    link: "parts/deliveries",
                    icon: AppImages.IconVehicles,
                    component: DashboardPartsDelivery,
                    showToRoles: ["SuperUser", "Admin", "Mechanic", "Parts Analyst"],
                },
                {
                    title: "Requests",
                    link: "parts/requests",
                    icon: AppImages.IconVehicles,
                    component: DashboardPartsRequests,
                    showToRoles: ["SuperUser", "Admin", "Parts Analyst"],
                },
            ],
        },
        {
            hidden: true,
            title: "Settings",
            link: "settings",
            icon: AppImages.IconSelling,
            component: DashboardNone,
        },
        {
            title: "Employees",
            link: "employees",
            icon: AppImages.IconEmployees,
            component: DashboardEmployees,
            showToRoles: ["SuperUser", "Admin"],
        },
        //{ title: 'Employee', link: 'employees/:id', icon: AppImages.IconEmployees, component: DashboardEmployeeDetails, hidden: true, },
        {
            hidden: true,
            title: "Payouts",
            link: "payouts",
            icon: AppImages.IconParts,
            component: DashboardNone,
        },
        {
            title: "Purchase Inventory",
            link: "purchase-inventory",
            icon: AppImages.IconPurchaseInventory,
            component: DashboardVehiclePurchaseInventory,
            showToRoles: ["SuperUser", "Admin"],
        },
        {
            hidden: true,
            title: "Locations",
            link: "locations",
            icon: AppImages.IconLocations,
            component: DashboardNone,
        },
        {
            hidden: true,
            title: "Selling",
            link: "selling",
            icon: AppImages.IconSelling,
            component: DashboardNone,
        },
        {
            hidden: true,
            title: "Reports & Stats",
            link: "reports-stats",
            icon: AppImages.IconReports,
            component: DashboardNone,
        },
    ],
    [
        {
            title: "Help & Support",
            link: "help",
            icon: AppImages.IconHelp,
            component: DashboardNone,
        },
        {
            title: "Sign Out",
            link: "signout",
            icon: AppImages.IconSignout,
            component: DashboardNone,
        },
    ],
];

function findDashboardPageByLink(link: string, pages: DashboardPage[]): DashboardPage | undefined {
    for (const page of pages) {
        if (page.link === link) {
            return page;
        }
        // Check if the current page has children and search recursively
        if (page.child) {
            const childResult = findDashboardPageByLink(link, page.child);
            if (childResult) {
                return childResult;
            }
        }
    }
    return undefined;
}

export function find_page(link: string): DashboardPage | undefined {
    for (const group of dashboard_pages) {
        const result = findDashboardPageByLink(link, group);
        if (result) {
            return result;
        }
    }

    return dashboard_pages[0][0];
}